/* ==========================================================================
   motion-producto.js — Nareva Home · "Motion · Producto" (tema Horizon)
   Variantes, tarjetas de oferta 1 pijama / pack (nombre, etiqueta, precio por
   unidad y ahorro según el escalón de precio del pack), precio en vivo,
   galería con puntos/flechas, fecha de entrega y añadir al carrito con el
   carrito lateral de Horizon (Shopify.actions). Sin JS, el formulario lleva al
   carrito con la oferta que viene marcada.
   ========================================================================== */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

  const flash = (el) => {
    if (!el || reduceMotion.matches || !el.animate) return;
    el.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: EASE });
  };

  const setText = (el, text, animate) => {
    if (!el) return;
    const value = text == null ? '' : String(text);
    if (el.textContent.trim() === value.trim()) return;
    el.textContent = value;
    if (animate && value) flash(el);
  };

  const formatMoney = (cents, format) => {
    const value = (Math.round(cents) / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const fmt = (format || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return withCommas;
        case 'amount_with_comma_separator': return withDots + ',' + dec;
        case 'amount_no_decimals_with_comma_separator': return withDots;
        case 'amount_with_period_and_space_separator': return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + dec;
        default: return withCommas + '.' + dec;
      }
    });
  };

  function initGallery(section) {
    const gallery = section.querySelector('[data-mtm-gallery]');
    if (!gallery) return { goToMedia: () => {} };
    const slides = Array.from(gallery.children);
    const dots = Array.from(section.querySelectorAll('[data-mtm-dot]'));
    const current = () => Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
    const goTo = (index) => {
      const target = slides[Math.max(0, Math.min(slides.length - 1, index))];
      if (!target) return;
      gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };
    let queued = false;
    gallery.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        const i = current();
        dots.forEach((dot, n) => dot.classList.toggle('is-active', n === i));
      });
    }, { passive: true });
    dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.mtmDot))));
    const prev = section.querySelector('[data-mtm-prev]');
    const next = section.querySelector('[data-mtm-next]');
    if (prev) prev.addEventListener('click', () => goTo(current() - 1));
    if (next) next.addEventListener('click', () => goTo(current() + 1));
    return {
      goToMedia(mediaId) {
        const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (index < 0 || index === current()) return;
        goTo(index);
        flash(slides[index]);
      },
    };
  }

  function initDelivery(section) {
    const el = section.querySelector('[data-mtm-delivery]');
    if (!el) return;
    const out = el.querySelector('[data-mtm-delivery-text]');
    const addBusinessDays = (days) => {
      const date = new Date();
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return date;
    };
    try {
      // "entre el 2 y el 9 de noviembre" (mismo mes) o "entre el 28 de octubre y el 6 de noviembre"
      const format = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { day: 'numeric', month: 'long' });
      const start = addBusinessDays(Number(el.dataset.min));
      const end = addBusinessDays(Number(el.dataset.max));
      const from = start.getMonth() === end.getMonth() ? String(start.getDate()) : format.format(start);
      const to = format.format(end);
      out.textContent = (el.dataset.template || 'Recíbelo entre el [desde] y el [hasta]').replace('[desde]', from).replace('[hasta]', to);
    } catch (e) {
      /* se queda el texto de días laborables */
    }
  }

  // items: [{ id, quantity }]. El pack se añade como 2 pijamas sueltos (así el
  // proveedor recibe cada color y el descuento automático "Pack 2 pijamas"
  // deja el precio del pack).
  async function addToCart(items) {
    const actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      const result = await actions.updateCart(
        { lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })) },
        { event: { context: 'product' } }
      );
      if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
      if (typeof actions.openCart === 'function') {
        try { await actions.openCart(); } catch (e) { /* el carrito ya se abre solo */ }
      }
      return 'drawer';
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map((item) => ({ id: Number(item.id), quantity: item.quantity })) }),
    });
    if (!res.ok) {
      let message = 'No se ha podido añadir. Inténtalo de nuevo.';
      try { message = (await res.json()).description || message; } catch (e) { /* nada */ }
      throw new Error(message);
    }
    window.location.href = root + 'cart';
    return 'page';
  }

  function initProduct(section) {
    if (section.dataset.mtmReady) return;
    section.dataset.mtmReady = '1';

    let data;
    try {
      data = JSON.parse(section.querySelector('[data-mtm-variants]').textContent);
    } catch (e) {
      return;
    }
    const form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const money = (cents) => formatMoney(cents, data.moneyFormat);
    const q = (selector) => section.querySelector(selector);

    const idInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const button = form.querySelector('[type="submit"]');
    const label = button.querySelector('[data-mtm-atc-label]');
    const atcPrice = button.querySelector('[data-mtm-atc-price]');
    const price = q('[data-mtm-price]');
    const compare = q('[data-mtm-compare]');
    const compareLabel = q('[data-mtm-compare-label]');
    const errorBox = q('[data-mtm-error]');
    const packPanel = q('[data-mtm-panel="pack"]');
    const gallery = initGallery(section);
    const singleSets = Array.from(section.querySelectorAll('[data-mtm-option="single"]'));
    const packSets = Array.from(section.querySelectorAll('[data-mtm-option="pack"]'));
    const modeInputs = Array.from(section.querySelectorAll('[data-mtm-mode]'));
    const tierRows = Array.from(section.querySelectorAll('[data-tier]'));
    const offer = {
      singleCompare: q('[data-offer-single-compare]'),
      singlePrice: q('[data-offer-single-price]'),
      packCard: q('[data-offer-card="pack"]'),
      packFlag: q('[data-offer-pack-flag]'),
      packName: q('[data-offer-pack-name]'),
      packUnit: q('[data-offer-pack-unit]'),
      packWas: q('[data-offer-pack-was]'),
      packCompare: q('[data-offer-pack-compare]'),
      packPrice: q('[data-offer-pack-price]'),
      packSave: q('[data-offer-pack-save]'),
    };
    const mode = () => {
      const checked = modeInputs.find((input) => input.checked);
      return checked ? checked.value : 'single';
    };
    // La barra fija dice qué se está comprando (en el pack: "Pack Duo · Azul marino + Rosa bebé").
    const stickyTitle = q('.mt-sticky-atc__title');
    const stickyBase = stickyTitle ? stickyTitle.textContent.trim() : '';

    const selected = (sets) => sets.map((set) => {
      const checked = set.querySelector('input:checked');
      return checked ? checked.value : null;
    });
    const find = (list, options) => (list || []).find((v) => v.options.every((value, i) => value === options[i]));

    const markAvailability = (sets, list, options) => {
      sets.forEach((set, position) => {
        set.querySelectorAll('input').forEach((input) => {
          const candidate = options.slice();
          candidate[position] = input.value;
          const variant = find(list, candidate);
          input.closest('.mtm-pill').classList.toggle('is-unavailable', !variant || !variant.available);
        });
        const shown = set.querySelector('[data-mtm-option-value]');
        if (shown) shown.textContent = options[position] || '';
      });
    };

    const tierName = (tier) => (data.tierNames && data.tierNames[tier]) || (data.tierNames && data.tierNames[0]) || 'Pack';

    // Tarjeta "1 pijama": siempre enseña el color elegido en el selector de 1 pijama.
    const renderSingleCard = (variant) => {
      if (!variant) return;
      setText(offer.singlePrice, variant.price, true);
      if (offer.singleCompare) {
        setText(offer.singleCompare, variant.compare || '');
        offer.singleCompare.hidden = !variant.compare;
      }
    };

    // Tarjeta pack: nombre, "Recomendado", precio por unidad y ahorro según el escalón.
    const renderPackCard = (variant) => {
      if (!variant || !offer.packCard) return;
      const best = variant.tier === 0;
      const extras = best || data.extrasAllTiers;
      offer.packCard.classList.toggle('is-best', best);
      if (offer.packFlag) offer.packFlag.hidden = !best;
      setText(offer.packName, tierName(variant.tier), true);
      setText(offer.packPrice, variant.price, true);
      if (offer.packWas) offer.packWas.hidden = !variant.compare;
      setText(offer.packCompare, variant.compare || '');
      if (offer.packUnit && data.unitText) {
        offer.packUnit.hidden = !extras;
        setText(offer.packUnit, data.unitText.replace('[precio]', money(variant.cents / 2)));
      }
      if (offer.packSave && data.saveText) {
        const diff = variant.compare ? variant.compareCents - variant.cents : 0;
        offer.packSave.hidden = !(extras && diff > 0);
        setText(offer.packSave, data.saveText.replace('[ahorro]', money(diff)));
      }
      tierRows.forEach((row) => row.classList.toggle('is-active', Number(row.dataset.tier) === variant.tier));
    };

    const setPrice = (variant) => {
      if (price) setText(price, variant.price, true);
      if (atcPrice) atcPrice.textContent = variant.price;
      if (compare) {
        compare.textContent = variant.compare || '';
        compare.hidden = !variant.compare;
      }
      if (compareLabel) compareLabel.hidden = !variant.compare;
    };

    const update = () => {
      const isPack = mode() === 'pack' && data.pack && data.pack.length;

      // Las dos tarjetas se mantienen al día, esté elegida una u otra.
      const singleOptions = selected(singleSets);
      const singleVariant = singleSets.length ? find(data.variants, singleOptions) : data.variants[0];
      const packOptions = selected(packSets);
      const packVariant = packSets.length ? find(data.pack, packOptions) : null;
      renderSingleCard(singleVariant);
      renderPackCard(packVariant);

      const sets = isPack ? packSets : singleSets;
      const list = isPack ? data.pack : data.variants;
      const options = isPack ? packOptions : singleOptions;
      markAvailability(sets, list, options);
      const variant = isPack ? packVariant : singleVariant;
      if (errorBox) errorBox.hidden = true;
      if (!variant) {
        button.disabled = true;
        label.textContent = data.unavailable;
        return;
      }
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (quantityInput) quantityInput.value = 1;
      setPrice(variant);
      if (stickyTitle) stickyTitle.textContent = isPack ? tierName(variant.tier) + ' · ' + options.join(' + ') : stickyBase;
      button.disabled = !variant.available;
      label.textContent = variant.available ? data.addToCart : data.soldOut;

      // La galería enseña el color elegido (en el pack, el del primer pijama).
      const mediaVariant = isPack ? data.variants.find((v) => v.options[0] === options[0]) : variant;
      if (mediaVariant && mediaVariant.media) gallery.goToMedia(mediaVariant.media);

      if (section.dataset.updateUrl === 'true' && !isPack) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    section.addEventListener('change', (event) => {
      if (event.target.matches('[data-mtm-mode]')) {
        if (event.target.value === 'pack' && packPanel && !reduceMotion.matches) {
          packPanel.classList.remove('is-entering');
          void packPanel.offsetWidth;
          packPanel.classList.add('is-entering');
        }
        update();
        return;
      }
      if (event.target.closest('[data-mtm-option]')) {
        // Tocar un color de un panel elige también su tarjeta.
        const set = event.target.closest('[data-mtm-option]');
        const wanted = set.dataset.mtmOption;
        const input = modeInputs.find((el) => el.value === wanted);
        if (input && !input.checked) input.checked = true;
        update();
      }
    });

    // Qué se añade al carrito: 1 pijama = su variante; pack = un pijama suelto
    // de cada color elegido (si son iguales, 2 del mismo).
    const mainItems = () => {
      const isPack = mode() === 'pack' && data.pack && data.pack.length && packSets.length;
      if (!isPack) return [{ id: idInput.value, quantity: Number(quantityInput ? quantityInput.value : 1) || 1 }];
      const colors = selected(packSets);
      const singles = colors.map((color) => data.variants.find((v) => v.options[0] === color));
      if (singles.some((v) => !v)) return [{ id: idInput.value, quantity: 1 }];
      if (singles[0].id === singles[1].id) return [{ id: singles[0].id, quantity: 2 }];
      return singles.map((v) => ({ id: v.id, quantity: 1 }));
    };

    // Complemento (snippets/hr-complemento.liquid): si la casilla está marcada,
    // se añade 1 unidad de la variante elegida junto con el pijama.
    const addon = q('[data-mtm-addon]');
    let addonVariants = [];
    if (addon) {
      try { addonVariants = JSON.parse(addon.querySelector('[data-mtm-addon-variants]').textContent); } catch (e) { addonVariants = []; }
    }
    const addonToggle = addon ? addon.querySelector('[data-mtm-addon-toggle]') : null;
    const addonOpts = addon ? addon.querySelector('[data-mtm-addon-opts]') : null;
    const addonSelects = addon ? Array.from(addon.querySelectorAll('[data-mtm-addon-option]')) : [];
    const addonVariant = () => {
      const values = addonSelects.map((s) => s.value);
      return addonVariants.find((v) => v.available && values.every((value, i) => v.options[i] === value));
    };
    const syncAddon = () => {
      // Cada desplegable (salvo el primero) solo deja elegir lo que existe con lo de antes.
      addonSelects.forEach((select, k) => {
        if (k === 0) return;
        Array.from(select.options).forEach((opt) => {
          opt.disabled = !addonVariants.some((v) => v.available && v.options[k] === opt.value &&
            addonSelects.every((s, i) => i >= k || v.options[i] === s.value));
        });
        if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
          const first = Array.from(select.options).find((opt) => !opt.disabled);
          if (first) select.value = first.value;
        }
      });
    };
    if (addon && addonToggle) {
      addonToggle.addEventListener('change', () => {
        addon.classList.toggle('is-on', addonToggle.checked);
        if (addonOpts) addonOpts.hidden = !addonToggle.checked;
      });
      addonSelects.forEach((select) => select.addEventListener('change', syncAddon));
      syncAddon();
    }

    const cartItems = () => {
      const items = mainItems();
      if (addonToggle && addonToggle.checked) {
        const v = addonSelects.length ? addonVariant() : addonVariants.find((x) => x.available);
        if (v) items.push({ id: v.id, quantity: 1 });
      }
      return items;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled || button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      if (errorBox) errorBox.hidden = true;
      try {
        const where = await addToCart(cartItems());
        if (where === 'drawer') {
          label.textContent = data.added;
          setTimeout(() => { label.textContent = data.addToCart; }, 1600);
        }
      } catch (error) {
        if (errorBox) {
          errorBox.textContent = error && error.message ? error.message : 'No se ha podido añadir. Inténtalo de nuevo.';
          errorBox.hidden = false;
        }
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    });

    // Enlaces que piden una oferta concreta: #pack / ?pack o ?variant= (1 pijama).
    const pick = (value) => {
      const input = modeInputs.find((el) => el.value === value);
      if (input) input.checked = true;
    };
    const params = new URLSearchParams(window.location.search);
    if (modeInputs.length) {
      if (window.location.hash === '#pack' || params.has('pack')) pick('pack');
      else if (params.has('variant')) pick('single');
    }
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href$="#pack"]');
      if (!link || !modeInputs.length) return;
      event.preventDefault();
      pick('pack');
      update();
      section.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
    });

    update();
    initDelivery(section);
  }

  const init = (root) => (root || document).querySelectorAll('[data-mtm-product]').forEach(initProduct);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
